import { render, staticRenderFns } from "./addControl.vue?vue&type=template&id=1026852f"
import script from "./addControl.vue?vue&type=script&lang=js"
export * from "./addControl.vue?vue&type=script&lang=js"
import style0 from "./addControl.vue?vue&type=style&index=0&id=1026852f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports